/**
 * Site-wide constants: single source of truth for values used across
 * multiple files. Change here, change everywhere.
 */

/** Public-facing contact address shown on pages, footers, and emails. */
export const CONTACT_EMAIL = "hello@costdoc.com.au";
export const CONTACT_EMAIL_LINK = `mailto:${CONTACT_EMAIL}`;

/** Operations / support address used for claim submissions and takedowns. */
export const SUPPORT_EMAIL = "support@costdoc.com.au";
export const SUPPORT_EMAIL_LINK = `mailto:${SUPPORT_EMAIL}`;

/**
 * From address for marketing / email-capture confirmations and follow-ups.
 * Monitored inbox (hello@). Prefer this when a human may receive a reply.
 */
export const EMAIL_SENDER = `CostDoc <${CONTACT_EMAIL}>`;

/**
 * From address for automated transactional mail (contact/takedown/claim/waitlist).
 * Use noreply so replies do not land in an unmonitored mailbox; set replyTo
 * to the submitter (or CONTACT_EMAIL) when operators need to reply.
 */
export const EMAIL_NOREPLY = "noreply@costdoc.com.au";
export const EMAIL_AUTOMATED_SENDER = `CostDoc <${EMAIL_NOREPLY}>`;
